






import Vue from "vue";
import Component from "vue-class-component";

@Component({
  name: "MarginReport"
})
export default class extends Vue {

  get isDesktop() { return this.$vuetify.breakpoint.smAndUp; }
  
  get componentInstance() {
    // const name = this.isDesktop ? "Grid" : "List";
    const name = "Grid";
    return () => import(`./${name}`);
  }
}
